import React, { useEffect, useState } from "react";
import { capitalizeFirstLetter } from "../utils/Functions";

// Function to filter data by date
const filterDataByDate = (data, days) => {
  const today = new Date();
  const pastDate = new Date();
  pastDate.setDate(today.getDate() - days);

  // Normalize both dates to just the date part (set time to 00:00:00)
  today.setHours(0, 0, 0, 0);
  pastDate.setHours(0, 0, 0, 0);

  return data.filter((item) => {
    const itemDate = new Date(item.createdAt);
    itemDate.setHours(0, 0, 0, 0); // Normalize item date as well
    return itemDate >= pastDate && itemDate <= today;
  });
};

// Function to count unique cities
const countUniqueCities = (data) => {
  if (data.length === 0) return [];

  const counts = data.reduce((acc, item) => {
    acc[item.city] = (acc[item.city] || 0) + 1;
    return acc;
  }, {});

  return Object.entries(counts).map(([city, count]) => ({
    name: city,
    count,
    percentage: (count / data.length) * 100, // Calculate percentage
  }));
};

// Main component
const AreaChart = ({ value, data }) => {
  const [cityCounts, setCityCounts] = useState([]);

  useEffect(() => {
    let filteredData;
    switch (value) {
      case "Today":
        filteredData = filterDataByDate(data, 0);
        break;
      case "Last 7 days":
        filteredData = filterDataByDate(data, 7);
        break;
      case "Last 30 days":
        filteredData = filterDataByDate(data, 30);
        break;
      default:
        filteredData = data;
        break;
    }

    // console.log("Filtered Data:", filteredData);

    // Count unique cities
    const counts = countUniqueCities(filteredData);
    setCityCounts(counts);
  }, [value, data]);

  return (
    <div className="w-[35%]  bg-white shadow rounded-2xl ml-2 mr-3">
      <h2 className="text-[14px] ml-2 p-3 font-semibold">Bookings By City</h2>
      <div className="border-b border-[#D7E4EB] mb-2"></div>
      <div className="space-y-3 ml-5" style={{ marginBottom: 10 }}>
        {cityCounts.map((city) => (
          <div
            key={city.name}
            className="flex flex-row justify-between items-center mt-4"
          >
            <div
              className="h-7 rounded-lg bg-[#DEEFFF]"
              style={{ width: `${city.percentage}%` }}
            >
              <span
                className="text-[12px] ml-3 min-w-[200px]"
                style={{
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                }}
              >
                {capitalizeFirstLetter(city.name)}
              </span>
            </div>
            <div className="ml-10 mr-4 text-[12px]">
              {Math.round(city.percentage)}%
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AreaChart;
